<template>
    <v-btn
        class="white--text ma-4"
        color="light-blue darken-4"
        href="https://github.com/keith-victor-dawson"
    >
        <v-icon class="blue--text text--lighten-3">{{ icons.github }}</v-icon>
        <span class="ml-2">View Profile</span>
    </v-btn>
</template>

<script>
import { mdiGithub } from '@mdi/js'

export default {
    name: 'GithubProfileButton',
    data() {
        return {
            icons: {
                github: mdiGithub,
            },
        }
    },
}
</script>

<style scoped>

</style>